import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObject20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMediaObject20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10 3.5H3.5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1H10a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1M3.5 2A2.5 2.5 0 0 0 1 4.5v11A2.5 2.5 0 0 0 3.5 18H10a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 10 2zm10.75 4.25A.75.75 0 0 1 15 5.5h3.238a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75M15 9a.75.75 0 0 0 0 1.5h2A.75.75 0 0 0 17 9z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObject20);
